
export enum Month {
  january = "january",
  february = "february",
  march = "march",
  april = "april",
  may = "may",
  june = "june",
  july = "july",
  august = "august",
  september = "september",
  october = "october",
  november = "november",
  december = "december",
}

export enum DaysOfWeek {

  SUN = "Sunday",
  MON =  "Monday ",
  TUE = "Tuesday",
  WED = "Wednesday",
  THU = "Thursday",
  FRI = "Friday",
  SAT = "Saturday"

}

export type CalendarProps = {
  name?: string
  months?: Month[]
  years?: number[]
  unlockDays?: Date[]
  lockDays?:Date[]
  selectedDay?: number
  selectedMonth?: Month
  selectedYear?: number
  readOnly?:boolean
  lockPast?:boolean
  lockAll?: boolean
}



export type LockPastProps  = {
  lockPast?: boolean
  readonly?: never,
  lockAll?: never
}

export type LockAllProps = {
  lockPast?: never,
  readonly?:never,
  lockAll?: boolean
}



export type ReadOnlyProps = {
  lockPast?: never,
  lockAll?: never,
  readonly?: boolean
}


export type StateProps = ReadOnlyProps | LockAllProps | LockPastProps
